import { Pipe, PipeTransform } from '@angular/core';
import { htmlUrls } from '@shared/utils/router-paths';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { UserActivityInfoModel } from '@shared/components/User-Activity-Info/model';

@Pipe({
  name: 'feedLinks',
  standalone: true
})
export class FeedLinksPipe implements PipeTransform {

  transform(verb: ActivityVerbEnum, id: string, objectType?: ObjectTypeEnum, objectId?: string, userName?: string): string {
    let link = '';
    if (verb === ActivityVerbEnum.Liked || verb === ActivityVerbEnum.Commented || verb === ActivityVerbEnum.Reacted) {
      link = this.checkObjectType(objectType!, objectId!);
    }
    else {
      switch (verb) {
        case ActivityVerbEnum.Posted:
          link = htmlUrls.post + objectId;
          break;
        case ActivityVerbEnum.Rated:
        case ActivityVerbEnum.Reviewed:
          link = htmlUrls.reviews + objectId;
          break;
        case ActivityVerbEnum.ReadingProgressed:
        case ActivityVerbEnum.StateChangedToRead:
        case ActivityVerbEnum.StateChangedIWantToRead:
        case ActivityVerbEnum.StateChangedToCurrently:
          link = htmlUrls.states + objectId;
          break;
        case ActivityVerbEnum.Booklisted:
          link = htmlUrls.bookList + objectId;
          break;
        case ActivityVerbEnum.Quoted:
          link = htmlUrls.quote + objectId;
          break;
        case ActivityVerbEnum.ChallengePicked:
          link = htmlUrls.challenge_detail + objectId;
          break;
        case ActivityVerbEnum.ChallengeObtained:
          link = htmlUrls.challenge_detail + objectId;
          break;
        case ActivityVerbEnum.AchievementObtained:
          link = htmlUrls.achieved_badge + objectId;
          break;
        case ActivityVerbEnum.Coursed:
        case ActivityVerbEnum.CourseEnded:
          link = htmlUrls.course_details + objectId;
          break;
        case ActivityVerbEnum.UserReportPublished:
          link = htmlUrls.annual_report + objectId;
          break;
        case ActivityVerbEnum.Followed:
          link = `${htmlUrls.profile}/${userName ?? id}`;
          break;
      }
    }
    return link;
  }

  checkObjectType(objectType: ObjectTypeEnum, objectId: string): string {
    let link = '';
    switch (objectType) {
      case ObjectTypeEnum.Post:
        link = htmlUrls.post + objectId;
        break;
      case ObjectTypeEnum.Progress:
        link = htmlUrls.states + objectId;
        break;
      case ObjectTypeEnum.Review:
        link = htmlUrls.reviews + objectId;
        break;
      case ObjectTypeEnum.Booklist:
        link = htmlUrls.comment_booklist + objectId;
        break;
      case ObjectTypeEnum.Quote:
        link = htmlUrls.quote + objectId;
        break;
      case ObjectTypeEnum.UserChallenge:
        link = htmlUrls.challenge_detail + objectId;
        break;
      case ObjectTypeEnum.badge:
        link = htmlUrls.achieved_badge + objectId;
        break;
      case ObjectTypeEnum.Club:
        link = htmlUrls.intro_club + objectId;
        break;
      case ObjectTypeEnum.Course:
        link = htmlUrls.course_details + objectId;
        break;
      case ObjectTypeEnum.UserReportPublished:
        link = htmlUrls.annual_report + objectId;
        break;
    }

    return link;
  }

}
